import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["hour", "minute", "submitButton", "errorMessage"]

    connect() {
        this.validateLaunchTime()
    }

    validateLaunchTime() {
        const hourSelect = this.element.querySelector("select[name*='hour']")
        const minuteSelect = this.element.querySelector("select[name*='minute']")
        const submitButton = this.element.closest("form").querySelector("input[type='submit']")

        if (!hourSelect || !minuteSelect || !submitButton) return

        hourSelect.addEventListener("change", () => this.checkTimeRestrictions(hourSelect, minuteSelect, submitButton))
        minuteSelect.addEventListener("change", () => this.checkTimeRestrictions(hourSelect, minuteSelect, submitButton))

        // Initial check
        this.checkTimeRestrictions(hourSelect, minuteSelect, submitButton)
    }

    checkTimeRestrictions(hourSelect, minuteSelect, submitButton) {
        const selectedHour = parseInt(hourSelect.value, 10)
        const selectedMinute = parseInt(minuteSelect.value, 10)

        // Check if the selected time is within allowed hours (5 AM to 10 PM ET)
        const isWithinAllowedHours = selectedHour >= 5 && selectedHour <= 22

        // Check if the selected time is at least 6 hours in the future
        const now = new Date()
        const selectedTime = new Date()
        selectedTime.setHours(selectedHour, selectedMinute, 0)

        // Add 6 hours to current time for the minimum allowed time
        const minAllowedTime = new Date(now.getTime() + (6 * 60 * 60 * 1000))

        // Get the error message container
        let errorContainer = this.element.querySelector(".time-error-message")
        if (!errorContainer) {
            errorContainer = document.createElement("div")
            errorContainer.className = "time-error-message text-red-600 text-sm mt-1"
            minuteSelect.parentNode.appendChild(errorContainer)
        }

        if (!isWithinAllowedHours) {
            errorContainer.textContent = "Launches are only allowed between 5 AM and 10 PM Eastern Time."
            submitButton.disabled = true
            submitButton.classList.add("opacity-50", "cursor-not-allowed")
        } else if (selectedTime < minAllowedTime) {
            errorContainer.textContent = "You can only schedule launches that are at least 6 hours in the future."
            submitButton.disabled = true
            submitButton.classList.add("opacity-50", "cursor-not-allowed")
        } else {
            errorContainer.textContent = ""
            submitButton.disabled = false
            submitButton.classList.remove("opacity-50", "cursor-not-allowed")
        }
    }
}